import { Sparkles } from "lucide-react";
import type { RefObject } from "react";
import type { SkillDefinition } from "../../api/types.js";

export function SkillSlashMenu({
  skills,
  activeIndex,
  onSelect,
  menuRef
}: {
  skills: SkillDefinition[];
  activeIndex: number;
  onSelect: (skill: SkillDefinition) => void;
  menuRef: RefObject<HTMLDivElement | null>;
}) {
  return (
    <div ref={menuRef} className="skill-slash-menu" id="composer-skill-list" role="listbox" aria-label="选择技能">
      {skills.map((skill, index) => (
        <button
          id={`composer-skill-option-${index}`}
          className={`skill-slash-option${index === activeIndex ? " is-active" : ""}`}
          type="button"
          role="option"
          aria-selected={index === activeIndex}
          key={`${skill.packSlug}:${skill.name}`}
          onMouseDown={(event) => event.preventDefault()}
          onClick={() => onSelect(skill)}
        >
          <Sparkles size={15} aria-hidden="true" />
          <span className="skill-slash-copy">
            <strong>{skill.displayName}</strong>
            <small>{skill.packDisplayName}</small>
          </span>
          <code>/{skill.name}</code>
        </button>
      ))}
    </div>
  );
}
